<template>
  <v-card>
    <v-img v-if="redeInfo && redeInfo.matriz.url_imagem_posto" :src="redeInfo.matriz.url_imagem_posto"
      aspect-ratio="2.75">
    </v-img>
    <v-card-text v-if="redeInfo">
      <v-layout justify-end>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn color="primary" small round v-on="on" @click="step === 1 ? step++ : step--">
              <v-icon class="mr-1">remove_red_eye</v-icon>
              {{ step === 1 ? 'Postos' : 'Detalhes' }}
            </v-btn>
          </template>
          <span>
            {{ step === 1 ? 'Visualizar postos da rede' : 'Visualizar detalhes da rede' }}
          </span>
        </v-tooltip>
      </v-layout>
      <v-stepper v-model="step" style="box-shadow: none;">
        <v-stepper-items>
          <v-stepper-content step="1">
            <v-layout row wrap justify-space-around fill-height>
              <v-flex xs12 class="headline text-xs-center pb-4 pt-4">Detalhes</v-flex>
              <v-flex xs12 sm5>
                <v-text-field readonly label="Nome da Rede" v-model="redeInfo.nome"></v-text-field>
              </v-flex>
              <v-flex xs12 sm5>
                <v-text-field readonly label="Posto matriz" v-model="redeInfo.matriz.nome_fantasia"></v-text-field>
              </v-flex>
              <v-flex xs12 sm5>
                <v-text-field readonly label="CNPJ" v-model="redeInfo.matriz.cnpj" mask="##.###.###/####-##"
                  class="text-xs-center"></v-text-field>
              </v-flex>
              <v-flex xs12 sm5 v-if="redeInfo.tipo_rede === 0">
                <v-text-field readonly label="CPF do representante" v-model="redeInfo.representante.cpf"
                  mask="###.###.###-##" class="text-xs-center"></v-text-field>
              </v-flex>
              <v-flex xs12 class="text-xs-center pt-2 pb-2">Endereço</v-flex>
              <template v-if="redeInfo.matriz.endereco">
                <v-flex xs5>
                  <v-text-field readonly label="Cidade" v-model="redeInfo.matriz.endereco.cidade"></v-text-field>
                </v-flex>
                <v-flex xs5>
                  <v-text-field readonly label="Bairro" v-model="redeInfo.matriz.endereco.bairro"></v-text-field>
                </v-flex>
                <v-flex xs5>
                  <v-text-field readonly label="Logradouro" v-model="redeInfo.matriz.endereco.logradouro"></v-text-field>
                </v-flex>
                <v-flex xs2>
                  <v-text-field readonly label="Número" v-model="redeInfo.matriz.endereco.numero"></v-text-field>
                </v-flex>
                <v-flex xs3>
                  <v-text-field readonly label="CEP" v-model="redeInfo.matriz.endereco.cep"
                    mask="#####-###"></v-text-field>
                </v-flex>
              </template>
            </v-layout>
          </v-stepper-content>
          <v-stepper-content step="2">
            <v-layout row wrap justify-center class="pa-2">
              <v-flex xs12>
                <h2 class="text-xs-center">Postos da Rede</h2>
              </v-flex>
              <v-flex xs12>
                <v-list style="border: 1px solid #BFBEBE; border-radius: 1em;  min-height: 30em;" class="mr-1">
                  <v-list-tile v-for="(posto, index) in postosDaRede" :key="index">
                    <v-list-tile-avatar>
                      <img v-if="posto.url_logo" :src="posto.url_logo" alt="logo posto" width="30">
                      <img v-else :src="require(`@/assets/logomarca.png`)" alt="logo posto" width="30">
                    </v-list-tile-avatar>
                    <v-list-tile-avatar style="width: 10%;">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }" v-if="posto.cnpj === rede.matriz.cnpj">
                          <v-icon v-on="on" class="ml-4" color="secondary">
                            star
                          </v-icon>
                        </template>
                        <span>Principal posto da rede</span>
                      </v-tooltip>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title class="text-xs-center">{{ posto.nome_fantasia }}</v-list-tile-title>
                      <v-list-tile-sub-title class="text-xs-center">{{ posto.cnpj }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile v-if="postosDaRede.length === 0">
                    <v-list-tile-content>
                      <v-list-tile-title class="text-xs-center">Sem postos no momento</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-flex>
            </v-layout>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat color="primary" @click="fechar">Voltar</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>

export default {
  props: ['rede'],
  data () {
    return {
      step: 1,
      redeInfo: null,
      postosDaRede: []
    }
  },
  watch: {
    rede (val) {
      if (val !== undefined || val !== null) {
        this.$store.dispatch('detalhesRede', this.val.id_rede).then(value => {
          this.redeInfo = value
          this.pegarPostoDaRede(val.id_rede)
        })
      }
    }
  },
  beforeMount () {
    if (this.rede && this.rede.id_rede) {
      this.$store.dispatch('detalhesRede', this.rede.id_rede).then(value => {
        this.redeInfo = value
      }).catch(() => {
        this.redeInfo = {
          matriz: {},
          representante: {}
        }
      })
      this.pegarPostoDaRede(this.rede.id_rede)
    }
  },
  methods: {
    fechar () {
      this.$emit('fechar')
      this.redeInfo = null
    },
    pegarPostoDaRede (id) {
      this.$store.dispatch('postosDaRede', id).then(value => {
        this.postosDaRede = value
      })
    }
  }
}
</script>
